import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { FieldCapability, FieldProficiencyLevel, FieldWorker, FieldWorkerCapability } from './field-work.models';

@Component({
  selector: 'app-field-worker-capability-dialog',
  standalone: true,
  imports: [
    CommonModule, FormsModule, AutoCompleteModule, ButtonModule, DatePickerModule, DialogModule,
    IftaLabelModule, InputGroupModule, InputGroupAddonModule, SelectModule
  ],
  templateUrl: './field-worker-capability-dialog.component.html',
  styleUrl: './field-worker-capability-dialog.component.css'
})
export class FieldWorkerCapabilityDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() saving = false;
  @Input() error = '';
  @Input() people: FieldWorker[] = [];
  @Input() capabilities: FieldCapability[] = [];
  @Input() proficiencyLevels: FieldProficiencyLevel[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() searchPeople = new EventEmitter<string>();
  @Output() assign = new EventEmitter<FieldWorkerCapability & { fieldWorkerId?: number }>();

  selectedWorker?: FieldWorker;
  form: FieldWorkerCapability = this.emptyForm();
  validationError = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) {
      this.reset();
      this.searchPeople.emit('');
    }
  }

  get capabilityOptions(): Array<{ label: string; value: number }> {
    return this.capabilities.filter(row => Boolean(row.fieldCapabilityId)).map(row => ({
      label: [row.capabilityName, row.capabilityCode].filter(Boolean).join(' â€” '),
      value: row.fieldCapabilityId!
    }));
  }

  get proficiencyOptions(): Array<{ label: string; value: number }> {
    return this.proficiencyLevels.filter(row => Boolean(row.fieldProficiencyLevelId)).map(row => ({
      label: `${row.levelName || row.levelCode || 'Level'}${row.levelRank != null ? ` â€” Rank ${row.levelRank}` : ''}`,
      value: row.fieldProficiencyLevelId!
    }));
  }

  searchWorkers(query: string): void {
    this.searchPeople.emit(query || '');
  }

  reset(): void {
    this.selectedWorker = undefined;
    this.form = this.emptyForm();
    this.validationError = '';
  }

  close(): void {
    if (!this.saving) this.visibleChange.emit(false);
  }

  submit(): void {
    this.validationError = '';
    if (!this.selectedWorker?.fieldWorkerId) {
      this.validationError = 'Select a field person.';
      return;
    }
    if (!this.form.fieldCapabilityId || !this.form.fieldProficiencyLevelId) {
      this.validationError = 'Capability and proficiency are required.';
      return;
    }
    this.assign.emit({ ...this.form, fieldWorkerId: this.selectedWorker.fieldWorkerId });
  }

  private emptyForm(): FieldWorkerCapability {
    return { status: 'ACTIVE', sourceType: 'MANUAL' };
  }
}
